<template>
  <router-link :to="mto" :event="event"><slot></slot></router-link>
</template>

<script>
export default {
  props: {
    to: String,
    event: {
      type: String,
      default: 'click'
    }
  },
  computed: {
    mto () {
      let lang = this.$store.state.lang.toLowerCase()
      if(lang === 'uk'){
        return '' + this.to
      }
      if(this.to === '/') {
        return `/${lang}`
      }
      if(!this.to) return ''
      return `/${lang}${this.to}`
    }
  }
}
</script>

<style>

</style>